module.exports = __webpack_public_path__ + "static/img/fudan.c3e1933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fudan.png
// module id = 8C7A
// module chunks = 26